/* ═══════════════════════════════════════════════════════════
   DARF — Pet Profile (Mein Hund Dashboard)
   Wizard onboarding + tabbed detail view
   Talks to darf-accounts-api Worker via window.__darfAuth
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  if (!window.__darfAuth) return;
  var app = document.getElementById('mh-app');
  if (!app) return;

  var AUTH = window.__darfAuth;
  var API  = AUTH.api.replace(/\/$/, '');

  var state = {
    pets: [],
    currentId: null,
    currentTab: 'profile',
    wizardStep: 1,
    ingredients: [],          /* loaded once: [{id, slug, name_de, category, is_common_allergen}] */
    selectedAllergyIds: [],   /* current pet's allergy IDs being edited */
    feedingPlan: null,        /* current pet's saved plan */
  };

  /* Product catalog injected via Liquid in section file */
  var PRODUCTS = { barf: [], cold: [], barf_handle: 'darf-frischfleisch-tiefgekuhlt', cold_handle: 'darf-kaltgepresst', barf_default_kcal: 1650, cold_default_kcal: 3700, currency: 'EUR' };
  try {
    var productEl = document.getElementById('darf-fp-products');
    if (productEl) PRODUCTS = Object.assign(PRODUCTS, JSON.parse(productEl.textContent));
  } catch (_) {}
  state.fpType = 'cold';      /* default to cold-pressed */
  state.fpVariantId = null;
  /* Heal weight=0 by parsing title */
  ['barf', 'cold'].forEach(function (key) {
    (PRODUCTS[key] || []).forEach(function (v) {
      if (!v.weight_g) v.weight_g = extractKgFromTitle(v.title, v.variant_title);
    });
  });

  /* Extract kg from product/variant title as last-resort weight */
  function extractKgFromTitle(t1, t2) {
    var combined = (t1 || '') + ' ' + (t2 || '');
    var m = combined.match(/(\d+(?:[.,]\d+)?)\s*kg/i);
    if (m) return parseFloat(m[1].replace(',', '.')) * 1000;
    var g = combined.match(/(\d+)\s*g\b/i);
    if (g) return parseInt(g[1], 10);
    return 0;
  }

  /* Fallback: fetch products from public storefront endpoint if Liquid emitted 0 */
  async function fetchCollectionFallback(type) {
    var handle = type === 'barf' ? PRODUCTS.barf_handle : PRODUCTS.cold_handle;
    var defaultKcal = type === 'barf' ? PRODUCTS.barf_default_kcal : PRODUCTS.cold_default_kcal;
    try {
      var r = await fetch('/collections/' + handle + '/products.json?limit=50');
      if (!r.ok) throw new Error('HTTP ' + r.status);
      var data = await r.json();
      var out = [];
      (data.products || []).forEach(function (p) {
        (p.variants || []).forEach(function (v) {
          if (!v.available) return;
          var weight_g = Math.round(v.grams || (v.weight || 0) * 1000);
          if (!weight_g) weight_g = extractKgFromTitle(p.title, v.title);
          out.push({
            variant_id: v.id,
            product_handle: p.handle,
            title: p.title,
            variant_title: v.title,
            weight_g: weight_g,
            price_cents: Math.round(parseFloat(v.price || 0) * 100),
            kcal_per_kg: defaultKcal,
            available: !!v.available,
            url: '/products/' + p.handle + '?variant=' + v.id,
          });
        });
      });
      PRODUCTS[type] = out;
    } catch (e) {
      /* silent */
    }
  }

  /* MER factors (NRC / Waltham) — species-aware. Hund & Katze teilen RER = 70 ×
     kg^0.75, aber unterschiedliche MER-Multiplikatoren; Katzen sind sedentärer
     und der Kastrationsstatus wirkt stärker. */
  var ACTIVITY_MOD = { calm: 0.875, normal: 1.0, active: 1.25, low: 0.875, moderate: 1.0, very_active: 1.25 };
  var STAGE_LABEL  = { puppy_young: 'Welpe', puppy: 'Junghund', adult: 'Erwachsen', senior: 'Senior' };
  var STAGE_LABEL_CAT = { puppy_young: 'Kitten (jung)', puppy: 'Kitten', adult: 'Erwachsen', senior: 'Senior' };

  function stageFactor(species, stage, neutered) {
    if (species === 'cat') {
      if (stage === 'puppy_young') return 2.5;   /* Kitten < 4 Mon. */
      if (stage === 'puppy')       return 2.0;   /* Kitten 4–12 Mon. */
      if (stage === 'senior')      return 1.1;
      return neutered ? 1.2 : 1.4;               /* adulte Katze */
    }
    if (stage === 'puppy_young') return 3.0;
    if (stage === 'puppy')       return 2.0;
    if (stage === 'senior')      return 1.4;
    return neutered ? 1.6 : 1.8;                 /* adulter Hund */
  }

  function autoStage(birthdate, species) {
    if (!birthdate) return 'adult';
    var d = new Date(birthdate);
    if (isNaN(d)) return 'adult';
    var months = (Date.now() - d.getTime()) / (30.44 * 24 * 3600 * 1000);
    if (months <= 4)  return 'puppy_young';
    if (months <= 12) return 'puppy';
    var seniorAt = species === 'cat' ? 132 : 84;   /* Katze 11 J., Hund 7 J. */
    if (months >= seniorAt) return 'senior';
    return 'adult';
  }

  function activityToCalmNormal(level) {
    if (!level) return 'normal';
    if (level === 'low')           return 'calm';
    if (level === 'moderate')      return 'normal';
    if (level === 'active' || level === 'very_active') return 'active';
    return level;
  }

  var $  = (sel, ctx) => (ctx || app).querySelector(sel);
  var $$ = (sel, ctx) => Array.from((ctx || app).querySelectorAll(sel));

  var loading = $('[data-loading]');
  var empty   = $('[data-empty]');
  var detail  = $('[data-detail]');
  var wizard  = $('[data-wizard]');
  var petsRow = $('[data-pets-row]');
  var addBtn  = $('[data-pet-add]');
  var addEmpty= $('[data-pet-add-empty]');
  var toast   = $('[data-toast]');

  function el(tag, props, text) {
    var n = document.createElement(tag);
    if (props) for (var k in props) {
      if (k === 'class') n.className = props[k];
      else if (k === 'data') for (var d in props[k]) n.dataset[d] = props[k][d];
      else n.setAttribute(k, props[k]);
    }
    if (text != null) n.textContent = text;
    return n;
  }

  /* ── Inline SVG icons (Lucide-style) — keeps the UI emoji-free ───────── */
var SVG_ICONS = {
    dog: '<line x1="128" y1="192" x2="128" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="144 176 128 192 112 176" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="104" y1="48" x2="152" y2="48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M104,48,50.37,32.24a8,8,0,0,0-9.8,6.29l-16.42,88c-1.54,8.23,9,13,14.16,6.42Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M152,48l53.63-15.76a8,8,0,0,1,9.8,6.29l16.42,88c1.54,8.23-9,13-14.16,6.42Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><circle cx="92" cy="140" r="12"/><circle cx="164" cy="140" r="12"/><path d="M208,120.38V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V120.38" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    cat: '<line x1="128" y1="192" x2="128" y2="224" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><circle cx="84" cy="140" r="12"/><circle cx="172" cy="140" r="12"/><line x1="128" y1="48" x2="128" y2="88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="144 176 128 192 112 176" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="96" y1="53.01" x2="96" y2="88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="160" y1="53.01" x2="160" y2="88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M67.6,67.6h0a102.87,102.87,0,0,1,120.8,0h0l21.94-25.24A8,8,0,0,1,224,48v88c0,48.6-43,88-96,88s-96-39.4-96-88V48a8,8,0,0,1,13.66-5.66Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    star: '<path d="M128,189.09l54.72,33.65a8.4,8.4,0,0,0,12.52-9.17l-14.88-62.79,48.7-42A8.46,8.46,0,0,0,224.27,94L160.36,88.8,135.74,29.2a8.36,8.36,0,0,0-15.48,0L95.64,88.8,31.73,94a8.46,8.46,0,0,0-4.79,14.83l48.7,42L60.76,213.57a8.4,8.4,0,0,0,12.52,9.17Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    gift: '<rect x="32" y="80" width="192" height="48" rx="8" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="80" x2="128" y2="208" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M176.79,31.21c9.34,9.34,9.89,25.06,0,33.82C159.88,80,128,80,128,80s0-31.88,15-48.79C151.73,21.32,167.45,21.87,176.79,31.21Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M79.21,31.21c-9.34,9.34-9.89,25.06,0,33.82C96.12,80,128,80,128,80s0-31.88-15-48.79C104.27,21.32,88.55,21.87,79.21,31.21Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    sparkles: '<path d="M84.27,171.73l-55.09-20.3a7.92,7.92,0,0,1,0-14.86l55.09-20.3,20.3-55.09a7.92,7.92,0,0,1,14.86,0l20.3,55.09,55.09,20.3a7.92,7.92,0,0,1,0,14.86l-55.09,20.3-20.3,55.09a7.92,7.92,0,0,1-14.86,0Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="176" y1="16" x2="176" y2="64" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="224" y1="72" x2="224" y2="104" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="152" y1="40" x2="200" y2="40" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="208" y1="88" x2="240" y2="88" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    wave: '<path d="M96.65,62a20,20,0,0,1,34.64-20l30,52" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M69.32,94.67,55.08,70A20,20,0,0,1,89.73,50l31.17,54" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M158.87,160A40,40,0,0,1,168,105.58L161.32,94A20,20,0,0,1,196,74l17.31,30A80,80,0,0,1,74.7,184l-40-69.32a20,20,0,0,1,34.64-20L88.57,128" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M192,33.78A51.84,51.84,0,0,1,223.67,58l.33.57" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M74.62,232A111.88,111.88,0,0,1,47,200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    trophy: '<line x1="96" y1="224" x2="160" y2="224" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="128" y1="184" x2="128" y2="224" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M58,128H48A32,32,0,0,1,16,96V80a8,8,0,0,1,8-8H56" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M198,128h10a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M56,48H200v63.1c0,39.7-31.75,72.6-71.45,72.9A72,72,0,0,1,56,112Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    paw: '<circle cx="212" cy="108" r="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><circle cx="44" cy="108" r="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><circle cx="92" cy="60" r="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><circle cx="164" cy="60" r="20" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M128,104A36,36,0,0,0,93.43,130a43.49,43.49,0,0,1-20.67,25.9,32,32,0,0,0,27.73,57.62,72.49,72.49,0,0,1,55,0,32,32,0,0,0,27.73-57.62A43.46,43.46,0,0,1,162.57,130,36,36,0,0,0,128,104Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    bone: '<path d="M56.32,199.68a28,28,0,1,1,10.51-51.42,8,8,0,0,0,10-1.07l70.38-70.38a8,8,0,0,0,1.07-10,28,28,0,1,1,51.42-10.51,28,28,0,1,1-10.51,51.42,8,8,0,0,0-10,1.07l-70.38,70.38a8,8,0,0,0-1.07,10,28,28,0,1,1-51.42,10.51Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>',
    meat: '<path d="M56.32,199.68a28,28,0,1,1,10.51-51.42,8,8,0,0,0,10-1.07l70.38-70.38a8,8,0,0,0,1.07-10,28,28,0,1,1,51.42-10.51,28,28,0,1,1-10.51,51.42,8,8,0,0,0-10,1.07l-70.38,70.38a8,8,0,0,0-1.07,10,28,28,0,1,1-51.42,10.51Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/>'
  };
  var EMOJI_MAP = { '🐶':'dog','🐕':'dog','🐱':'cat','🐈':'cat','⭐':'star','🌟':'star','🎁':'gift','✨':'sparkles','👋':'wave','🏆':'trophy','🐾':'paw','🦴':'bone','🥩':'meat','🍖':'meat' };
  function darfSvg(name, size) {
    size = size || 20; var p = SVG_ICONS[name]; if (!p) return '';
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">' + p + '</svg>';
  }
  // Resolve a value (emoji or icon name) to an icon name, or null to keep as text.
  function iconNameFor(val) {
    if (!val) return 'star';
    if (EMOJI_MAP[val]) return EMOJI_MAP[val];
    if (SVG_ICONS[val]) return val;
    if (/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}]/u.test(val)) return 'star';
    return null; // not an emoji (e.g. a bullet) -> keep as plain text
  }
  function setIcon(node, val, size) {
    var name = iconNameFor(val);
    if (name) node.innerHTML = darfSvg(name, size);
    else node.textContent = val;
  }

  /* ── API ────────────────────────────────────────────────── */
  /* The session token is minted asynchronously (App Proxy); every call waits
     for it, so the boot sequence and user actions never race the handshake. */
  function ready() { return Promise.resolve(AUTH.ready || AUTH.token); }
  function api(method, path, body, contentType) {
    return ready().then(function () { return apiNow(method, path, body, contentType); });
  }
  function apiNow(method, path, body, contentType) {
    var headers = { Authorization: 'Bearer ' + AUTH.token };
    var opts = { method, headers };
    if (body !== undefined) {
      if (body instanceof ArrayBuffer || body instanceof Blob) {
        opts.body = body;
        if (contentType) headers['Content-Type'] = contentType;
      } else {
        opts.body = JSON.stringify(body);
        headers['Content-Type'] = 'application/json';
      }
    }
    return fetch(API + path, opts).then(async function (r) {
      var data = null;
      try { data = await r.json(); } catch (_) {}
      if (!r.ok) {
        var msg = (data && (data.message || data.error)) || ('HTTP ' + r.status);
        var err = new Error(msg);
        err.status = r.status;
        err.data = data;
        throw err;
      }
      return data;
    });
  }

  /* ── UI helpers ─────────────────────────────────────────── */
  function setLoading(on) { loading.hidden = !on; }

  function showToast(message, isError) {
    toast.textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;
    clearTimeout(showToast._t);
    showToast._t = setTimeout(function () { toast.hidden = true; }, 3000);
  }

  function hideAllPanels() {
    detail.hidden = true;
    wizard.hidden = true;
    empty.hidden  = true;
  }

  /* ── Pet card row ───────────────────────────────────────── */
  function renderPetsRow() {
    $$('.mh-pet-card', petsRow).forEach(c => c.remove());

    var frag = document.createDocumentFragment();
    state.pets.forEach(function (pet) {
      var card = el('button', {
        type: 'button',
        class: 'mh-pet-card' + (pet.id === state.currentId ? ' is-active' : ''),
        data: { petId: pet.id }
      });

      var avatar = el('div', { class: 'mh-pet-card__avatar' });
      if (pet.photo_url) {
        var img = el('img');
        img.src = API + pet.photo_url;
        img.alt = '';
        avatar.appendChild(img);
      } else {
        avatar.innerHTML = darfSvg(pet.species === 'cat' ? 'cat' : 'dog', 30);
      }

      var info = el('div');
      info.appendChild(el('div', { class: 'mh-pet-card__name' }, pet.name));
      info.appendChild(el('div', { class: 'mh-pet-card__sub' },
        pet.weight_g ? (pet.weight_g / 1000).toFixed(1) + ' kg' : 'Profil ergänzen'));

      card.append(avatar, info);
      card.addEventListener('click', function () { selectPet(pet.id); });
      frag.appendChild(card);
    });
    petsRow.insertBefore(frag, addBtn);

    addBtn.hidden = state.pets.length >= 10;
    petsRow.hidden = state.pets.length === 0;
  }

  /* ── Detail / tabs ──────────────────────────────────────── */
  function renderDetail() {
    var pet = state.pets.find(p => p.id === state.currentId);
    if (!pet) { hideAllPanels(); return; }

    hideAllPanels();
    detail.hidden = false;
    app.dataset.species = pet.species === 'cat' ? 'cat' : 'dog';

    /* Identity strip */
    $('[data-identity-name]', detail).textContent = pet.name;
    var subParts = [];
    if (pet.breed) subParts.push(pet.breed);
    if (pet.weight_g) subParts.push((pet.weight_g / 1000).toFixed(1) + ' kg');
    if (pet.birthdate) {
      var age = computeAge(pet.birthdate);
      if (age) subParts.push(age);
    }
    $('[data-identity-sub]', detail).textContent = subParts.join(' · ') || 'Profil ergänzen für Empfehlungen';

    /* Photo */
    var photoEl = $('[data-pet-photo]', detail);
    var ph      = $('[data-photo-placeholder]', detail);
    if (pet.photo_url) {
      photoEl.src = API + pet.photo_url;
      photoEl.hidden = false; ph.style.display = 'none';
    } else {
      photoEl.hidden = true; photoEl.removeAttribute('src');
      ph.style.display = '';
      ph.innerHTML = darfSvg(pet.species === 'cat' ? 'cat' : 'dog', 30);
    }

    /* Form fields */
    setField('name',           pet.name);
    setField('breed',          pet.breed);
    setField('birthdate',      pet.birthdate);
    setField('weight_kg',      pet.weight_g ? (pet.weight_g / 1000) : '');
    setField('size_class',     pet.size_class || '');
    setField('activity_level', pet.activity_level || '');
    setField('species',        pet.species || 'dog');
    setField('neutered',       pet.neutered);
    setField('notes',          pet.notes || '');

    state.selectedAllergyIds = (pet.allergy_ids || []).slice();
    renderAllergySelector();

    /* Weight current */
    var wc = $('[data-weight-current]', detail);
    var wcVal = $('[data-weight-current-val]', detail);
    if (pet.weight_g) {
      wc.hidden = false;
      wcVal.textContent = (pet.weight_g / 1000).toFixed(1) + ' kg';
    } else {
      wc.hidden = true;
    }

    if (state.currentTab === 'weight') loadWeights();
  }

  function activateTab(tabName) {
    state.currentTab = tabName;
    $$('.mh-tab', detail).forEach(t => {
      var on = t.dataset.tab === tabName;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-tab-panel]', detail).forEach(p => {
      p.hidden = p.dataset.tabPanel !== tabName;
    });
    if (tabName === 'weight')  loadWeights();
    if (tabName === 'health')  { loadIngredients().then(renderAllergySelector); }
    if (tabName === 'feeding') {
      var pet = state.pets.find(p => p.id === state.currentId);
      prefillFeedingForm(pet);
      loadCurrentFeedingPlan();
    }
  }

  function setField(name, value) {
    var node = $('[name="' + name + '"]', detail);
    if (!node) return;
    if (node.type === 'checkbox') node.checked = !!value;
    else node.value = value == null ? '' : value;
  }

  function readForm() {
    var get = name => {
      var node = $('[name="' + name + '"]', detail);
      if (!node) return null;
      if (node.type === 'checkbox') return node.checked;
      return node.value || null;
    };
    var weight_kg = parseFloat(get('weight_kg'));
    return {
      name: (get('name') || '').trim(),
      species: get('species') || 'dog',
      breed: get('breed'),
      birthdate: get('birthdate'),
      weight_g: isFinite(weight_kg) && weight_kg > 0 ? Math.round(weight_kg * 1000) : null,
      size_class: get('size_class'),
      activity_level: get('activity_level'),
      neutered: get('neutered'),
      allergy_ids: state.selectedAllergyIds,
      notes: get('notes'),
    };
  }

  function computeAge(birthdate) {
    var d = new Date(birthdate);
    if (isNaN(d)) return null;
    var ms = Date.now() - d.getTime();
    var years = ms / (365.25 * 24 * 3600 * 1000);
    if (years < 1) {
      var months = Math.round(years * 12);
      return months + (months === 1 ? ' Monat' : ' Monate');
    }
    var y = Math.floor(years);
    return y + (y === 1 ? ' Jahr' : ' Jahre');
  }

  /* ── Wizard ─────────────────────────────────────────────── */
  function openWizard() {
    hideAllPanels();
    wizard.hidden = false;
    state.wizardStep = 1;
    renderWizardStep();
    /* Reset form */
    $$('[name^="w_"]', wizard).forEach(n => {
      if (n.type === 'checkbox') n.checked = false;
      else n.value = n.tagName === 'SELECT' ? n.querySelector('option').value : '';
    });
    /* Focus first input */
    setTimeout(() => $('[name="w_name"]', wizard).focus(), 50);
  }

  function closeWizard() {
    if (state.pets.length > 0) {
      state.currentId = state.currentId || state.pets[0].id;
      renderDetail();
    } else {
      hideAllPanels();
      empty.hidden = false;
    }
    wizard.hidden = true;
  }

  function renderWizardStep() {
    /* Hide all steps, show current */
    $$('[data-step]', wizard).forEach(s => {
      s.hidden = parseInt(s.dataset.step, 10) !== state.wizardStep;
    });
    /* Update step indicators */
    $$('[data-step-indicator]', wizard).forEach(li => {
      var n = parseInt(li.dataset.stepIndicator, 10);
      li.classList.toggle('is-active', n === state.wizardStep);
      li.classList.toggle('is-done', n < state.wizardStep);
    });
    /* Update nav buttons */
    $('[data-wizard-prev]', wizard).hidden = state.wizardStep === 1;
    $('[data-wizard-next]', wizard).hidden = state.wizardStep === 4;
    $('[data-wizard-finish]', wizard).hidden = state.wizardStep !== 4;
    $('[data-wizard-count]', wizard).textContent = state.wizardStep + ' / 4';
  }

  function validateWizardStep() {
    if (state.wizardStep === 1) {
      var name = $('[name="w_name"]', wizard).value.trim();
      if (!name) {
        showToast('Bitte gib einen Namen ein', true);
        $('[name="w_name"]', wizard).focus();
        return false;
      }
    }
    if (state.wizardStep === 3) {
      var w = $('[name="w_weight"]', wizard).value;
      if (w && (parseFloat(w) <= 0 || parseFloat(w) > 200)) {
        showToast('Gewicht muss zwischen 0,1 und 200 kg liegen', true);
        return false;
      }
    }
    return true;
  }

  function readWizard() {
    var v = name => $('[name="' + name + '"]', wizard).value;
    var c = name => $('[name="' + name + '"]', wizard).checked;
    var weightKg = parseFloat(v('w_weight'));
    return {
      name: v('w_name').trim(),
      species: v('w_species'),
      breed: v('w_breed') || null,
      birthdate: v('w_birthdate') || null,
      weight_g: isFinite(weightKg) && weightKg > 0 ? Math.round(weightKg * 1000) : null,
      size_class: v('w_size') || null,
      activity_level: v('w_activity') || null,
      neutered: c('w_neutered'),
      notes: v('w_notes') || null,
    };
  }

  async function finishWizard() {
    if (!validateWizardStep()) return;
    var data = readWizard();
    setLoading(true);
    try {
      var r = await api('POST', '/accounts/pets', data);
      state.pets.push(r.pet);
      state.currentId = r.pet.id;
      state.currentTab = 'profile';
      activateTab('profile');
      renderPetsRow();
      renderDetail();
      showToast('Willkommen, ' + data.name);
    } catch (e) {
      showToast(e.message, true);
    } finally { setLoading(false); }
  }

  /* ── Pet actions ────────────────────────────────────────── */
  async function refreshPets(selectFirst) {
    setLoading(true);
    try {
      var r = await api('GET', '/accounts/pets');
      state.pets = r.pets || [];
      if (state.pets.length === 0) {
        hideAllPanels();
        empty.hidden = false;
        petsRow.hidden = true;
      } else {
        if (selectFirst || !state.currentId || !state.pets.find(p => p.id === state.currentId)) {
          state.currentId = state.pets[0].id;
        }
        renderPetsRow();
        renderDetail();
      }
    } catch (e) {
      showToast('Profil konnte nicht geladen werden: ' + e.message, true);
    } finally {
      setLoading(false);
    }
  }

  function selectPet(id) {
    state.currentId = id;
    renderPetsRow();
    renderDetail();
  }

  async function savePet() {
    if (!state.currentId) return;
    var data = readForm();
    if (!data.name) { showToast('Name ist erforderlich', true); return; }
    setLoading(true);
    try {
      var r = await api('PATCH', '/accounts/pets/' + state.currentId, data);
      var idx = state.pets.findIndex(p => p.id === state.currentId);
      if (idx >= 0) state.pets[idx] = r.pet;
      renderPetsRow();
      renderDetail();
      showToast('Gespeichert ✓');
    } catch (e) {
      showToast(e.message, true);
    } finally { setLoading(false); }
  }

  async function deletePet() {
    if (!state.currentId) return;
    var ok;
    if (window.DarfConfirm) {
      ok = await window.DarfConfirm({
        message: 'Diesen Hund wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
        confirmLabel: 'Ja, löschen', cancelLabel: 'Abbrechen', danger: true
      });
    } else {
      ok = confirm('Diesen Hund wirklich löschen?');
    }
    if (!ok) return;
    setLoading(true);
    try {
      await api('DELETE', '/accounts/pets/' + state.currentId);
      state.pets = state.pets.filter(p => p.id !== state.currentId);
      state.currentId = null;
      await refreshPets(true);
      showToast('Hund gelöscht');
    } catch (e) {
      showToast(e.message, true);
    } finally { setLoading(false); }
  }

  async function uploadPhoto(file) {
    if (!state.currentId || !file) return;
    if (file.size > 5 * 1024 * 1024) { showToast('Datei zu groß (max 5 MB)', true); return; }
    setLoading(true);
    try {
      var buf = await file.arrayBuffer();
      var r = await api('POST', '/accounts/pets/' + state.currentId + '/photo', buf, file.type);
      var idx = state.pets.findIndex(p => p.id === state.currentId);
      if (idx >= 0) {
        state.pets[idx].photo_key = r.photo_key;
        state.pets[idx].photo_url = r.url;
      }
      renderPetsRow();
      renderDetail();
      showToast('Foto hochgeladen ✓');
    } catch (e) {
      showToast(e.message, true);
    } finally { setLoading(false); }
  }

  /* ── Weights ────────────────────────────────────────────── */
  async function loadWeights() {
    if (!state.currentId) return;
    var list = $('[data-weight-list]', detail);
    var emptyMsg = $('[data-weight-empty]', detail);
    try {
      var r = await api('GET', '/accounts/pets/' + state.currentId + '/weights');
      list.querySelectorAll('.mh-weight-row').forEach(n => n.remove());
      if (!r.weights.length) { emptyMsg.hidden = false; return; }
      emptyMsg.hidden = true;
      r.weights.slice(0, 20).forEach(function (w) {
        var d = new Date(w.measured_at * 1000);
        var row = el('div', { class: 'mh-weight-row' });
        row.appendChild(el('span', { class: 'mh-weight-row__date' },
          d.toLocaleDateString('de-DE', { day: '2-digit', month: 'short', year: 'numeric' })));
        row.appendChild(el('span', { class: 'mh-weight-row__val' },
          (w.weight_g / 1000).toFixed(1) + ' kg'));
        list.appendChild(row);
      });
    } catch (e) { /* silent */ }
  }

  function showWeightForm() {
    var form = $('[data-weight-form]', detail);
    var pet = state.pets.find(p => p.id === state.currentId);
    var input = form.querySelector('[name="new_weight"]');
    input.value = pet && pet.weight_g ? (pet.weight_g / 1000).toFixed(1) : '';
    form.hidden = false;
    setTimeout(() => input.focus(), 50);
  }

  function hideWeightForm() {
    $('[data-weight-form]', detail).hidden = true;
  }

  async function submitWeight(e) {
    e.preventDefault();
    if (!state.currentId) return;
    var input = e.target.querySelector('[name="new_weight"]');
    var kg = parseFloat((input.value || '').replace(',', '.'));
    if (!isFinite(kg) || kg <= 0 || kg > 200) {
      showToast('Gewicht muss zwischen 0,1 und 200 kg liegen', true);
      input.focus();
      return;
    }
    setLoading(true);
    try {
      await api('POST', '/accounts/pets/' + state.currentId + '/weights', { weight_g: Math.round(kg * 1000) });
      var idx = state.pets.findIndex(p => p.id === state.currentId);
      if (idx >= 0) state.pets[idx].weight_g = Math.round(kg * 1000);
      hideWeightForm();
      renderPetsRow();
      renderDetail();
      loadWeights();
      showToast('Gewicht eingetragen ✓');
    } catch (err) {
      showToast(err.message, true);
    } finally { setLoading(false); }
  }

  /* ── Ingredient selector ─────────────────────────────────── */
  var CAT_LABELS = {
    protein: 'Protein',
    cereal: 'Getreide',
    legume: 'Hülsenfrüchte',
    vegetable: 'Gemüse',
    fruit: 'Obst',
    oil: 'Öle & Fette',
    supplement: 'Sonstige',
    other: 'Sonstige Stoffe'
  };
  var CAT_ORDER = ['protein', 'cereal', 'legume', 'vegetable', 'fruit', 'oil', 'supplement', 'other'];

  async function loadIngredients() {
    if (state.ingredients.length) return;
    try {
      var r = await fetch(API + '/accounts/ingredients');
      var data = await r.json();
      state.ingredients = data.ingredients || [];
    } catch (e) {
      state.ingredients = [];
    }
  }

  function renderAllergySelector() {
    var listEl = $('[data-allergy-list]', detail);
    var selectedEl = $('[data-allergy-selected]', detail);
    var search = $('[data-allergy-search]', detail);
    if (!listEl) return;

    /* Render selected pills */
    while (selectedEl.firstChild) selectedEl.removeChild(selectedEl.firstChild);
    if (state.selectedAllergyIds.length === 0) {
      selectedEl.appendChild(el('p', { class: 'mh-muted' }, 'Noch keine Allergien ausgewählt.'));
    } else {
      state.selectedAllergyIds.forEach(function (id) {
        var ing = state.ingredients.find(i => i.id === id);
        if (!ing) return;
        var pill = el('span', { class: 'mh-allergy-pill' });
        pill.appendChild(document.createTextNode(ing.name_de));
        var rm = el('button', { type: 'button', class: 'mh-allergy-pill__x', 'aria-label': 'Entfernen' }, '×');
        rm.addEventListener('click', () => toggleAllergy(id));
        pill.appendChild(rm);
        selectedEl.appendChild(pill);
      });
    }

    /* Render category list */
    while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
    if (!state.ingredients.length) {
      listEl.appendChild(el('p', { class: 'mh-muted' }, 'Zutaten werden geladen...'));
      return;
    }

    var filter = (search.value || '').toLowerCase().trim();
    var filtered = state.ingredients.filter(function (i) {
      if (!filter) return true;
      var hay = (i.name_de + ' ' + (i.name_en || '') + ' ' + (i.search_keywords || '')).toLowerCase();
      return hay.indexOf(filter) !== -1;
    });

    var byCat = {};
    filtered.forEach(i => {
      (byCat[i.category] = byCat[i.category] || []).push(i);
    });

    var anyShown = false;
    CAT_ORDER.forEach(function (cat) {
      if (!byCat[cat] || !byCat[cat].length) return;
      anyShown = true;
      var catEl = el('div', { class: 'mh-allergy-cat' });
      catEl.appendChild(el('div', { class: 'mh-allergy-cat__title' }, CAT_LABELS[cat] || cat));
      var items = el('div', { class: 'mh-allergy-cat__items' });
      byCat[cat].forEach(function (ing) {
        var selected = state.selectedAllergyIds.indexOf(ing.id) !== -1;
        var chip = el('button', {
          type: 'button',
          class: 'mh-allergy-chip' + (selected ? ' is-selected' : '') + (ing.is_common_allergen ? ' is-allergen' : ''),
          data: { ingId: String(ing.id) }
        }, ing.name_de);
        chip.addEventListener('click', () => toggleAllergy(ing.id));
        items.appendChild(chip);
      });
      catEl.appendChild(items);
      listEl.appendChild(catEl);
    });

    if (!anyShown) {
      listEl.appendChild(el('p', { class: 'mh-muted' }, 'Keine Treffer für „' + filter + '"'));
    }
  }

  function toggleAllergy(id) {
    var idx = state.selectedAllergyIds.indexOf(id);
    if (idx === -1) state.selectedAllergyIds.push(id);
    else state.selectedAllergyIds.splice(idx, 1);
    renderAllergySelector();
  }

  /* ── Feeding plan calculator (product-aware) ─────────────── */
  function calcMER() {
    var weightKg = parseFloat($('[name="fp_weight"]', detail).value);
    var stage    = $('[name="fp_stage"]', detail).value || 'adult';
    var activity = $('[name="fp_activity"]', detail).value || 'normal';
    if (!isFinite(weightKg) || weightKg <= 0) return null;
    var pet = state.pets.find(function (p) { return p.id === state.currentId; }) || {};
    var species = pet.species || 'dog';
    var rer = 70 * Math.pow(weightKg, 0.75);
    var stageF = stageFactor(species, stage, pet.neutered);
    var actMod = stage === 'adult' ? (ACTIVITY_MOD[activity] || 1.0) : 1.0;
    return { mer_kcal: rer * stageF * actMod, weight_kg: weightKg, stage, activity, species };
  }

  function formatMoney(cents, currency) {
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(amount);
    } catch (_) {
      return amount.toFixed(2) + ' €';
    }
  }

  function getCurrentVariant() {
    var list = PRODUCTS[state.fpType] || [];
    return list.find(v => v.variant_id === state.fpVariantId) || null;
  }

  async function populateProductSelect() {
    var select = $('[data-fp-product]', detail);
    while (select.firstChild) select.removeChild(select.firstChild);

    var list = PRODUCTS[state.fpType] || [];
    /* If Liquid emitted nothing, try public storefront fetch */
    if (!list.length) {
      select.appendChild(el('option', { value: '' }, 'Lade…'));
      await fetchCollectionFallback(state.fpType);
      list = PRODUCTS[state.fpType] || [];
      while (select.firstChild) select.removeChild(select.firstChild);
    }
    if (!list.length) {
      select.appendChild(el('option', { value: '' }, 'Keine Produkte verfügbar'));
      state.fpVariantId = null;
      return;
    }

    /* Optional placeholder */
    select.appendChild(el('option', { value: '' }, 'Bitte auswählen…'));

    list.forEach(function (v) {
      if (!v.available) return;
      var label = v.title;
      if (v.variant_title && v.variant_title !== 'Default Title') label += ' — ' + v.variant_title;
      var opt = el('option', { value: String(v.variant_id) }, label);
      select.appendChild(opt);
    });

    /* Default: keep saved variant_id if matching, else first available */
    var available = list.filter(v => v.available);
    if (available.length && !available.find(v => v.variant_id === state.fpVariantId)) {
      state.fpVariantId = available[0].variant_id;
    }
    select.value = state.fpVariantId ? String(state.fpVariantId) : '';
  }

  async function setFpType(type) {
    state.fpType = type;
    $$('[data-fp-type]', detail).forEach(b => {
      var on = b.dataset.fpType === type;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    state.fpVariantId = null;
    await populateProductSelect();
    updateFeedingPlanUI();
  }

  function updateFeedingPlanUI() {
    var summary = $('[data-fp-mer-summary]', detail);
    var result  = $('[data-fp-result]', detail);
    var meta    = $('[data-fp-product-meta]', detail);

    var mer = calcMER();
    if (!mer) {
      summary.hidden = true; result.hidden = true; meta.hidden = true;
      return;
    }
    summary.hidden = false;
    $('[data-fp-mer]', detail).textContent = Math.round(mer.mer_kcal);

    var v = getCurrentVariant();
    if (!v) { result.hidden = true; meta.hidden = true; return; }

    /* Final heal: ensure weight_g > 0 by parsing title even at calc time */
    if (!v.weight_g || v.weight_g <= 0) {
      v.weight_g = extractKgFromTitle(v.title, v.variant_title);
    }
    if (!v.weight_g || v.weight_g <= 0) {
      result.hidden = true; meta.hidden = true;
      return;
    }

    /* Show product meta */
    meta.hidden = false;
    $('[data-fp-product-kcal]', detail).textContent   = v.kcal_per_kg;
    $('[data-fp-product-weight]', detail).textContent = (v.weight_g / 1000).toFixed(1) + ' kg';

    /* Compute */
    var gramsPerDay  = mer.mer_kcal * 1000 / v.kcal_per_kg;
    var packsMonth   = (gramsPerDay * 30) / v.weight_g;
    var supplyDays   = v.weight_g / gramsPerDay;
    var costMonth    = packsMonth * v.price_cents;

    /* Render */
    result.hidden = false;
    var sub = (v.weight_g / 1000).toFixed(1) + ' kg · ' + v.kcal_per_kg + ' kcal/kg · ' + formatMoney(v.price_cents, PRODUCTS.currency);
    $('[data-fp-result-title]', detail).textContent = v.title + (v.variant_title && v.variant_title !== 'Default Title' ? ' — ' + v.variant_title : '');
    $('[data-fp-result-sub]', detail).textContent   = sub;
    $('[data-fp-grams]', detail).textContent   = Math.round(gramsPerDay);
    $('[data-fp-supply]', detail).textContent  = Math.floor(supplyDays);
    $('[data-fp-monthly]', detail).textContent = (Math.round(packsMonth * 10) / 10).toFixed(1);
    $('[data-fp-cost]', detail).textContent    = formatMoney(Math.round(costMonth), PRODUCTS.currency);

    var link = $('[data-fp-product-link]', detail);
    link.href = v.url;
  }

  async function prefillFeedingForm(pet) {
    if (!pet) return;
    if (pet.weight_g) $('[name="fp_weight"]', detail).value = (pet.weight_g / 1000).toFixed(1);
    $('[name="fp_stage"]', detail).value = autoStage(pet.birthdate, pet.species);
    $('[name="fp_activity"]', detail).value = activityToCalmNormal(pet.activity_level);

    if (state.feedingPlan && state.feedingPlan.variant_id) {
      var combined = (PRODUCTS.barf || []).concat(PRODUCTS.cold || []);
      var found = combined.find(v => v.variant_id === state.feedingPlan.variant_id);
      if (found) {
        var inBarf = (PRODUCTS.barf || []).indexOf(found) !== -1;
        state.fpType = inBarf ? 'barf' : 'cold';
        state.fpVariantId = found.variant_id;
        await setFpType(state.fpType);
        $('[data-fp-product]', detail).value = String(state.fpVariantId);
      } else {
        await populateProductSelect();
      }
    } else {
      await populateProductSelect();
    }
    updateFeedingPlanUI();
  }

  async function loadCurrentFeedingPlan() {
    if (!state.currentId) return;
    try {
      var r = await api('GET', '/accounts/pets/' + state.currentId + '/feeding-plan');
      state.feedingPlan = r.plan;
      var current = $('[data-fp-current]', detail);
      var text = $('[data-fp-current-text]', detail);
      if (r.plan) {
        current.hidden = false;
        var label = 'Aktiver Plan: ' + r.plan.daily_grams + ' g/Tag';
        if (r.plan.variant_id) {
          var combined = (PRODUCTS.barf || []).concat(PRODUCTS.cold || []);
          var v = combined.find(p => p.variant_id === r.plan.variant_id);
          if (v) label += ' · ' + v.title + (v.variant_title && v.variant_title !== 'Default Title' ? ' (' + v.variant_title + ')' : '');
        }
        text.textContent = label;
      } else {
        current.hidden = true;
      }
    } catch (e) { /* silent */ }
  }

  async function saveFeedingPlan() {
    var mer = calcMER();
    var v = getCurrentVariant();
    if (!mer || !v) { showToast('Bitte Gewicht und Produkt auswählen', true); return; }
    var grams = Math.round(mer.mer_kcal * 1000 / v.kcal_per_kg);
    setLoading(true);
    try {
      await api('POST', '/accounts/pets/' + state.currentId + '/feeding-plan', {
        daily_grams: grams,
        product_handle: v.product_handle,
        variant_id: v.variant_id,
        formula_used: 'MER-NRC-' + state.fpType.toUpperCase()
      });
      await loadCurrentFeedingPlan();
      showToast('Plan gespeichert ✓');
    } catch (e) {
      showToast(e.message, true);
    } finally { setLoading(false); }
  }

  /* ── Wire events ────────────────────────────────────────── */
  addBtn.addEventListener('click', openWizard);
  if (addEmpty) addEmpty.addEventListener('click', openWizard);

  $('[data-wizard-cancel]', wizard).addEventListener('click', closeWizard);
  $('[data-wizard-prev]', wizard).addEventListener('click', () => {
    if (state.wizardStep > 1) { state.wizardStep--; renderWizardStep(); }
  });
  $('[data-wizard-next]', wizard).addEventListener('click', () => {
    if (!validateWizardStep()) return;
    if (state.wizardStep < 4) { state.wizardStep++; renderWizardStep(); }
  });
  $('[data-wizard-finish]', wizard).addEventListener('click', finishWizard);

  /* Wizard: Enter advances, only on step 1-3 */
  wizard.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
      if (state.wizardStep < 4) {
        if (validateWizardStep()) { state.wizardStep++; renderWizardStep(); }
      } else finishWizard();
    }
  });

  /* Tabs */
  $$('.mh-tab', detail).forEach(t => t.addEventListener('click', () => activateTab(t.dataset.tab)));

  /* Save / delete (multiple buttons) */
  $$('[data-pet-save]', detail).forEach(b => b.addEventListener('click', savePet));
  $$('[data-pet-delete]', detail).forEach(b => b.addEventListener('click', deletePet));

  $('[data-weight-add]', detail).addEventListener('click', showWeightForm);
  $('[data-weight-cancel]', detail).addEventListener('click', hideWeightForm);
  $('[data-weight-form]', detail).addEventListener('submit', submitWeight);

  var merBtn = $('[data-pet-mer]', detail);
  if (merBtn) merBtn.addEventListener('click', openMer);

  /* Allergy search */
  var allergySearch = $('[data-allergy-search]', detail);
  if (allergySearch) {
    allergySearch.addEventListener('input', renderAllergySelector);
  }

  /* Feeding plan: live recalc on input change */
  $$('[data-fp-input]', detail).forEach(function (input) {
    input.addEventListener('input', updateFeedingPlanUI);
    input.addEventListener('change', updateFeedingPlanUI);
  });
  /* Type toggle */
  $$('[data-fp-type]', detail).forEach(function (btn) {
    btn.addEventListener('click', () => setFpType(btn.dataset.fpType));
  });
  /* Product change */
  var productSel = $('[data-fp-product]', detail);
  if (productSel) {
    productSel.addEventListener('change', function () {
      var v = parseInt(productSel.value, 10);
      state.fpVariantId = isFinite(v) ? v : null;
      updateFeedingPlanUI();
    });
  }
  /* Save plan */
  $('[data-fp-save]', detail).addEventListener('click', saveFeedingPlan);
  var photoInput = $('[data-photo-input]', detail);
  $('[data-photo-upload]', detail).addEventListener('click', () => photoInput.click());
  photoInput.addEventListener('change', e => {
    if (e.target.files[0]) uploadPhoto(e.target.files[0]);
  });

  /* ── Treuepunkte (Loyalty) ──────────────────────────────── */
  var treueLoaded = false;

  function treueReasonMeta(data) {
    // Build reason key → {label, icon} from earn_rules, plus redeem/special.
    var map = {};
    (data.earn_rules || []).forEach(function (r) { map[r.key] = { label: r.label, icon: r.icon || '⭐' }; });
    map['redeem']  = { label: 'Prämie eingelöst', icon: '🎁' };
    map['admin']   = { label: 'Bonus', icon: '✨' };
    map['signup']  = { label: 'Willkommensbonus', icon: '👋' };
    return map;
  }

  function renderTreue(data) {
    var root = document.querySelector('[data-treue-root]');
    if (!root) return;
    root.textContent = '';
    var meta = treueReasonMeta(data);

    /* Hero: balance + tier + progress */
    var hero = el('div', { class: 'mh-treue-hero' });
    hero.appendChild(el('div', { class: 'mh-treue-hero__lbl' }, 'Dein Guthaben'));
    var bal = el('div', { class: 'mh-treue-hero__bal' });
    bal.appendChild(el('span', { class: 'mh-treue-hero__num' }, String(data.balance)));
    bal.appendChild(el('span', { class: 'mh-treue-hero__unit' }, 'Punkte'));
    hero.appendChild(bal);

    var tierRow = el('div', { class: 'mh-treue-hero__tier' });
    tierRow.appendChild(el('span', { class: 'mh-treue-badge' }, (data.tier && data.tier.label) || '—'));
    hero.appendChild(tierRow);

    if (data.next_tier) {
      var pct = Math.max(4, Math.min(100, Math.round((data.lifetime / data.next_tier.at) * 100)));
      var bar = el('div', { class: 'mh-treue-prog' });
      var fill = el('div', { class: 'mh-treue-prog__fill' });
      fill.style.width = pct + '%';
      bar.appendChild(fill);
      hero.appendChild(bar);
      hero.appendChild(el('div', { class: 'mh-treue-hero__next' },
        'Noch ' + data.next_tier.remaining + ' Punkte bis ' + data.next_tier.label));
    } else {
      hero.appendChild(el('div', { class: 'mh-treue-hero__next' }, 'Höchste Stufe erreicht'));
    }
    root.appendChild(hero);

    /* Prämien (redemption tiers) */
    root.appendChild(secHead('Prämien einlösen'));
    var grid = el('div', { class: 'mh-treue-grid' });
    (data.redemption_tiers || []).forEach(function (t) {
      var affordable = data.balance >= t.points_required;
      var card = el('div', { class: 'mh-treue-pram' + (affordable ? ' is-ready' : '') });
      card.appendChild(el('div', { class: 'mh-treue-pram__val' }, t.label));
      card.appendChild(el('div', { class: 'mh-treue-pram__pts' }, t.points_required + ' Punkte'));
      if (t.description) card.appendChild(el('div', { class: 'mh-treue-pram__desc' }, t.description));
      var btn = el('button', { class: 'mh-treue-pram__btn', type: 'button' },
        affordable ? 'Einlösen' : (t.points_required - data.balance) + ' fehlen');
      btn.disabled = !affordable;
      if (affordable) btn.addEventListener('click', function () { redeemTier(t.id, t.label, btn); });
      card.appendChild(btn);
      grid.appendChild(card);
    });
    root.appendChild(grid);

    /* Deine Gutscheine (active redemptions) */
    var active = (data.redemptions || []).filter(function (r) { return r.status === 'active' || r.status === 'pending_shopify'; });
    if (active.length) {
      root.appendChild(secHead('Deine Gutscheine'));
      var codeWrap = el('div', { class: 'mh-treue-codes' });
      active.forEach(function (r) {
        var row = el('div', { class: 'mh-treue-code' });
        var info = el('div', { class: 'mh-treue-code__info' });
        info.appendChild(el('span', { class: 'mh-treue-code__val' }, formatMoney(r.discount_value)));
        var exp = r.expires_at ? new Date(r.expires_at * 1000).toLocaleDateString('de-DE', { day: '2-digit', month: 'short', year: 'numeric' }) : '';
        info.appendChild(el('span', { class: 'mh-treue-code__exp' }, exp ? 'Gültig bis ' + exp : ''));
        row.appendChild(info);
        var codeBtn = el('button', { class: 'mh-treue-code__code', type: 'button', title: 'Code kopieren' }, r.discount_code);
        codeBtn.addEventListener('click', function () {
          try { navigator.clipboard.writeText(r.discount_code); showToast('Code kopiert'); } catch (_) {}
        });
        row.appendChild(codeBtn);
        codeWrap.appendChild(row);
      });
      root.appendChild(codeWrap);
    }

    /* Punkte sammeln (earn rules) */
    root.appendChild(secHead('So sammelst du Punkte'));
    var earnWrap = el('div', { class: 'mh-treue-earn' });
    (data.earn_rules || []).forEach(function (r) {
      var row = el('div', { class: 'mh-treue-earn__row' });
      var earnIcn = el('div', { class: 'mh-treue-earn__icn' }); setIcon(earnIcn, r.icon, 20); row.appendChild(earnIcn);
      var txt = el('div', { class: 'mh-treue-earn__txt' });
      txt.appendChild(el('b', null, r.label));
      if (r.description) txt.appendChild(el('small', null, r.description));
      row.appendChild(txt);
      var pts = r.category === 'purchase' ? '1 P/€' : '+' + r.points;
      row.appendChild(el('div', { class: 'mh-treue-earn__pts' }, pts));
      earnWrap.appendChild(row);
    });
    root.appendChild(earnWrap);

    /* Verlauf (history log) */
    if ((data.log || []).length) {
      root.appendChild(secHead('Verlauf'));
      var logWrap = el('div', { class: 'mh-treue-log' });
      data.log.forEach(function (e) {
        var m = meta[e.reason] || { label: e.reason, icon: '•' };
        var row = el('div', { class: 'mh-treue-log__row' });
        var logIcn = el('div', { class: 'mh-treue-log__icn' }); setIcon(logIcn, m.icon, 18); row.appendChild(logIcn);
        var txt = el('div', { class: 'mh-treue-log__txt' });
        txt.appendChild(el('b', null, m.label));
        txt.appendChild(el('small', null, new Date(e.created_at * 1000).toLocaleDateString('de-DE', { day: '2-digit', month: 'short', year: 'numeric' })));
        row.appendChild(txt);
        var d = el('div', { class: 'mh-treue-log__delta ' + (e.delta < 0 ? 'is-neg' : 'is-pos') },
          (e.delta < 0 ? '' : '+') + e.delta);
        row.appendChild(d);
        logWrap.appendChild(row);
      });
      root.appendChild(logWrap);
    }
  }

  function secHead(title) {
    var h = el('div', { class: 'mh-sec-head' });
    h.appendChild(el('h3', null, title));
    return h;
  }

  async function loadPoints(force) {
    var root = document.querySelector('[data-treue-root]');
    if (!root) return;
    if (treueLoaded && !force) return;
    root.innerHTML = '<div class="mh-treue-skel"></div><div class="mh-treue-skel"></div>';
    try {
      var data = await api('GET', '/accounts/points');
      treueLoaded = true;
      renderTreue(data);
    } catch (e) {
      root.innerHTML = '';
      root.appendChild(el('div', { class: 'mh-treue-err' }, 'Treuepunkte konnten nicht geladen werden.'));
    }
  }

  async function redeemTier(tierId, label, btn) {
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    try {
      var r = await api('POST', '/accounts/redeem', { tier_id: tierId });
      showToast('Gutschein "' + label + '" erstellt: ' + r.code);
      await loadPoints(true);
    } catch (e) {
      showToast(e.message || 'Einlösen fehlgeschlagen', true);
      if (btn) { btn.disabled = false; btn.textContent = 'Einlösen'; }
    }
  }

  /* ── Expose API for v2 inline view-switcher (mein-hund-dashboard.liquid) ── */
  window.__darfPetLoadPoints = function(){ return loadPoints(false); };
  window.__darfPetState = function(){ return state; };
  window.__darfPetProducts = function(){ return PRODUCTS; };
  window.__darfPetSelect = function(id){ selectPet(id); };
  window.__darfPetActivateTab = function(tab){ activateTab(tab); };
  window.__darfPetOpenWizard = function(){ openWizard(); };
  window.__darfPetLoadFeedingPlan = function(){ return loadCurrentFeedingPlan(); };

  /* ── Boot ───────────────────────────────────────────────── */
  app.dataset.state = 'ready';
  refreshPets(true);
})();
